import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type AuthState = AuthStateNotAuthenticated | UserAuthStateAuthenticated

export interface UserAuthStateAuthenticated {
  isAuthenticated: true
  user: UserDto
}

interface AuthActions {
  updateAuth: (state: AuthState) => void
}

interface AuthStateNotAuthenticated {
  isAuthenticated: false
  user: undefined
}

interface UserDto {
  clientId?: string
  email: string
  firstName: string
  id: string
  lastName: string
}

export const useAuthStore = create<AuthActions & AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      updateAuth: (state) => {
        set(state)
      },
      user: undefined,
    }),
    {
      name: 'auth',
      partialize: (state): AuthState =>
        state.isAuthenticated && state.user
          ? {
              isAuthenticated: true,
              user: (() => ({
                ...state.user,
                accessToken: undefined,
              }))(),
            }
          : {
              isAuthenticated: false,
              user: undefined,
            },
      storage: createJSONStorage<AuthState>(() => localStorage),
    }
  )
)
